export const YT_ACADEMIA_MATRITENSE_URL = 'https://youtube.com';
